var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.currentRouteName)+" "),_c('v-spacer'),_c('v-btn',{attrs:{"depressed":"","color":"info"}},[_vm._v(" add new invoice ")])],1),_c('v-divider'),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.invoices}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }